import React, { useMemo } from 'react';
import ServerAppContentHeader from './ServerAppContentHeader';
import TogoContentHeader from './TogoContentHeader';
import DriveThruContentHeader from './DriveThruContentHeader';
import getDeviceType from '@utility/deviceType';
import { connect } from 'react-redux';
import CallCenterContentHeader from './CallCenterContentHeader/index';

const MenuContentHeader = ({ seat, serverAppTheme }) => {
  const deviceType = useMemo(() => getDeviceType(seat), [seat]);

  const getHeaderBasedOnType = () => {
    if (deviceType.isTogo)
      return (
        <TogoContentHeader
          seat={seat}
          serverAppTheme={serverAppTheme}
        />
      );
    else if (deviceType.isCallCenter)
      return (
        <CallCenterContentHeader seat={seat} serverAppTheme={serverAppTheme} />
      );
    else if (deviceType?.isDriveThru || deviceType?.isCounter)
      return (
        <DriveThruContentHeader
          seat={seat}
          serverAppTheme={serverAppTheme}
        />
      );
    else if (!deviceType?.isSpeedOrderMode) {
      return <ServerAppContentHeader />;
    } else return;
  };

  return <>{getHeaderBasedOnType()}</>;
};

const mapStateToProps = ({ orders, theme }) => ({
  seat: orders.seats ?? {},
  serverAppTheme: theme?.serverAppTheme ?? {},
});

const MemoizedMenuContentHeader = React.memo(MenuContentHeader);

export default connect(mapStateToProps)(MemoizedMenuContentHeader);
